// Ограничение матч-мейкинга рейтинговых матчей по числу ПРОТИВНИКОВ
// (настраивается игроком на экране настройки поиска): опции 1-5 противников
// соответствуют матчам на 2-6 игроков. Выбраны все опции = без ограничений.
export const RANK_MATCH_OPPONENT_COUNT_OPTIONS = [1, 2, 3, 4, 5];

// Меньше N выбранных опций оставить нельзя — иначе поиск выродится в
// ожидание единственного редкого размера матча.
// ВРЕМЕННО ослаблено до 1 (можно оставить единственную опцию; последний
// заполненный чекбокс по-прежнему не снимается). ДЛЯ ВОССТАНОВЛЕНИЯ прежнего
// ограничения: вернуть значение 2 — модалка (гейт снятия и подсказка про
// минимум, см. RankMatchOpponentCountsModal), sanitizeOpponentCounts ниже и
// серверная валидация /api/rank-match/opponent-counts читают эту константу
export const RANK_MATCH_MIN_SELECTED_OPPONENT_COUNTS = 1;

// Типичная длительность матча (минуты) по числу противников — ориентир для
// игрока в модалке выбора ограничения, на экране настройки и на плашке поиска
export const RANK_MATCH_DURATION_MINUTES_BY_OPPONENT_COUNT = {
  1: [15, 20],
  2: [20, 35],
  3: [30, 45],
  4: [40, 60],
  5: [40, 80],
};

// null/пустой список/полный набор опций — все равно что «без ограничений»
export const checkIfUnrestrictedOpponentCounts = (opponentCounts) =>
  !Array.isArray(opponentCounts)
  || opponentCounts.length === 0
  || RANK_MATCH_OPPONENT_COUNT_OPTIONS.every((count) => opponentCounts.includes(count));

// Приводит произвольный ввод к отсортированному списку валидных опций без
// дублей; null — если ограничений по факту нет (или ввод не валиден)
export const sanitizeOpponentCounts = (opponentCounts) => {
  if (!Array.isArray(opponentCounts)) {
    return null;
  }
  const sanitized = [...new Set(opponentCounts)]
    .filter((count) => RANK_MATCH_OPPONENT_COUNT_OPTIONS.includes(count))
    .sort((a, b) => a - b);
  if (sanitized.length < RANK_MATCH_MIN_SELECTED_OPPONENT_COUNTS
    || sanitized.length === RANK_MATCH_OPPONENT_COUNT_OPTIONS.length
  ) {
    return null;
  }
  return sanitized;
};

// Код закрытия сокета ожидания, чей поиск перехватил повторный вход того же
// игрока — другая вкладка, другое устройство или та же страница после
// перезагрузки (см. /api/rank-match/join в server/index.js). Клиент показывает
// «поиск продолжен в другом окне», а не обрыв связи
export const RANK_MATCH_SEARCH_SUPERSEDED_CLOSE_CODE = 4005;
